import { loadScript } from './helpers.js'

/**
 * Get code from api
 *
 * @param function callback
 * @param string action
 * @return void
 */
function send( callback, action = 'social' )
{
  grecaptcha.ready( () => {
    grecaptcha
      .execute( process.env.MIX_G_RECAPTCHA_KEY, { action } )
      .then( callback )
  })
}

/**
 * Initialize script
 *
 * @return void
 */
function init()
{
  loadScript( `https://www.google.com/recaptcha/api.js?render=${process.env.MIX_G_RECAPTCHA_KEY}` )
}

export default {
  key: process.env.MIX_G_RECAPTCHA_KEY,
  init,
  send,
}
